import React, { Component } from "react";
import Box from "@mui/material/Box";
import LoadingButton from '@mui/lab/LoadingButton';
import BirthPicker from "../components/BirthPicker";
import Picker from "../components/Picker/Picker";
import axios from "axios";

import logoImage from "../assets/images/splash-logo.png";
import CardComponent from "./Ui/CardComponent";
import { AddToHomeScreen } from 'react-pwa-add-to-homescreen';

class Home extends Component {
  state = {
    right: {
      type: '...',
      power: '0.00 0.00',
      count: 1
    },
    left: {
      type: '...',
      power: '0.00 0.00',
      count: 1
    },
    eye: 'right',
    isOpen: false,
    isRightExist: "",
    isLeftExist: "",
    loading: false,
    rightList: {
      hasItem: false,
      list: []
    },
    leftList: {
      hasItem: false,
      list: []
    }
  };
  handleSubmit = (event) => {
    this.setState({loading: true, isRightExist: "", isLeftExist: "", rightList: {hasItem: false, list: []}, leftList: {hasItem: false, list: []}});
    const requests = [];
    event.preventDefault();
    if (Object.keys(this.state.right).length && this.state.right.type !== '...') {
      const rightSearch = this.state.right.power.split(' ');
      const rightRequest = axios
        .post("https://api.hesabfa.com/v1/item/getitems", {
          apiKey: "Bg8e7O4fLCU4cjUwbKRWjH7nS0S5Kgit",
          loginToken:
            "3787a4bd4b191006fc79b2be0dabc6bfe0ee16e57b4d14123ebaff2578eca616303ae740ce30218317cbcda4e60ee74f",
          queryInfo: {
            Search: "Tokai " + rightSearch[0] + '  ' + rightSearch[1],
            SearchFields: ["Name"],
          },
        })
        .then(({ data }) => {
          let result = data.Result.List;
          const rightExistance = result.find((item) => {
            return (
              item.Name ===
              this.state.right.type.split(' ')[0] + " Tokai " + rightSearch[0] + '  ' + rightSearch[1]
            );
          });
          if (rightExistance && rightExistance.Stock >= this.state.right.count) {
            this.setState({ isRightExist: "exist", rightList: {hasItem: false, list: []} });
          } else {
            if (rightExistance) {
              result = result.filter( item => (item.Id !== rightExistance.Id && item.Stock >= this.state.right.count));
            }
            this.setState({ isRightExist: "not-exist", rightList: {hasItem: Boolean(result.length), list: result} });
          }
        });
        requests.push(rightRequest);
    } else {
      this.setState({
        isRightExist: '',
      });
    }
    if (Object.keys(this.state.left).length && this.state.left.type !== '...') {
      const leftSearch = this.state.left.power.split(' ');
      const leftRequest = axios
        .post("https://api.hesabfa.com/v1/item/getitems", {
          apiKey: "Bg8e7O4fLCU4cjUwbKRWjH7nS0S5Kgit",
          loginToken:
            "3787a4bd4b191006fc79b2be0dabc6bfe0ee16e57b4d14123ebaff2578eca616303ae740ce30218317cbcda4e60ee74f",
          queryInfo: {
            Search: "Tokai " + leftSearch[0] + '  ' + leftSearch[1],
            SearchFields: ["Name"],
          },
        })
        .then(({ data }) => {
          let result = data.Result.List;
          const leftExistance = result.find((item) => {
            return (
              item.Name ===
              this.state.left.type.split(' ')[0] + " Tokai " + leftSearch[0] + '  ' + leftSearch[1]
            );
          });
          if (leftExistance && leftExistance.Stock >= this.state.left.count) {
            this.setState({ isLeftExist: "exist", leftList: {hasItem: false, list: []} });
          } else {
            if (leftExistance) {
              result = result.filter( item => (item.Id !== leftExistance.Id && item.Stock >= this.state.left.count));
            }
            this.setState({ isLeftExist: "not-exist", leftList: {hasItem: Boolean(result.length), list: result} });
          }
        });
        requests.push(leftRequest);
    } else {
      this.setState({
        isLeftExist: '',
      });
    }
    Promise.all(requests).then(() => {
      this.setState({loading: false});
    });
    return false;
  };
  selectHandler = (data) => {
    if (data.side === "چشم راست") {
      this.setState({
        right: {
          ...this.state.right,
          type: data.type
        }
      });
    } else {
      this.setState({
        left: {
          ...this.state.left,
          type: data.type
        }
      });
    }
  };
  powerSelectHandler = powerSelected => {
    const values = powerSelected.split(' ');
    this.setState({
      [this.state.eye]: {
        ...this.state[this.state.eye],
        power: values[0] + ' ' + values[1],
        count: values[2]
      },
      isOpen: false
    })
  }
  toggleHandler = side => {
    if (side === 'چشم راست') {
      this.setState({ isRightExist: '' });
    } else if (side === 'چشم چپ') {
      this.setState({ isLeftExist: '' });
    } else {
      this.setState({ isOpen: !this.state.isOpen, eye: side })
    }
  }

  render() {
    const valuePower = this.state.eye === 'right' ? this.state.right.power + ' ' + this.state.right.count : this.state.left.power + ' ' + this.state.left.count;
    return (
      <>
        <AddToHomeScreen translate={{ chromiumInstall: 'آیا مایل به نصب اپلیکیشن هستید؟', buttonInstall: 'نصب', safariTapShare: 'روی آیکن Share بزنید', safariAddHomeScreen: 'و گزینه "Add to home screen" را انتخاب کنید'}} />
        <div className="page">
          <header className="page-header text-center">
            <img alt="Japanese Technology" src={logoImage} width="70" />
          </header>
          <main className="page-body">
            <BirthPicker
              title="چشم راست"
              data={this.state.right}
              onToggle={this.toggleHandler}
              isExist={this.state.isRightExist}
              onSelect={this.selectHandler}
            />
            <BirthPicker
              title="چشم چپ"
              data={this.state.left}
              onToggle={this.toggleHandler}
              isExist={this.state.isLeftExist}
              onSelect={this.selectHandler}
            />
            <Picker
              value={valuePower}
              isOpen={this.state.isOpen}
              onSelect={this.powerSelectHandler}
              onCancel={this.toggleHandler}
            />
            <Box
              component="form"
              noValidate
              onSubmit={this.handleSubmit}
              sx={{ mt: 1, textAlign: "center" }}
            >
              <LoadingButton
                type="submit"
                loading={this.state.loading}
                variant="contained"
                sx={{ mt: 3, mb: 2, mx: "auto", px: 5 }}
                size="large"
              >
                استعلام موجودی
              </LoadingButton>
            </Box>
            { this.state.rightList.hasItem && <Box sx={{ px: 2 }}>
              <p className="exist-header">
                <span>چشم راست</span> در مدلهای زیر موجود میباشد:
              </p>
              {this.state.rightList.list.map(item => {
                return <CardComponent key={item.Id} title={item.Name} />
              })}
            </Box> }
            { this.state.leftList.hasItem && <Box sx={{ px: 2 }}>
              <p className="exist-header">
                <span>چشم چپ</span> در مدلهای زیر موجود میباشد:
              </p>
              <Box>
                {this.state.leftList.list.map(item => {
                  return <CardComponent key={item.Id} title={item.Name} />
                })}
              </Box>
            </Box> }
          </main>
        </div>
      </>
    );
  }
}

export default Home;
